export const createCleanURL = (text) => {
    return text
      .replace(/[^\w\s-]/g, '') 
      .replace(/\s+/g, '-')    
      .toLowerCase();          
  };